import { useQuery, UseQueryOptions } from 'react-query';
import { getPaymentsUrl } from '@frontend/api-payments';
import { getInterScreenQueryOptions } from '@frontend/payments-hooks';
import { getPaymentsPlatformQueryKey } from '../../utils/query-key';

export type UsePaymentUrlProps = {
  locationId: string;
};

export const USE_PAYMENT_URL_KEY = 'payments-url';

export const getUsePaymentsUrlQueryKey = (locationId: string) => {
  return getPaymentsPlatformQueryKey(USE_PAYMENT_URL_KEY, locationId);
};

export type UsePaymentsUrlProps = {
  locationId: string;
};
export const usePaymentsUrl = (
  { locationId }: UsePaymentsUrlProps,
  options: UseQueryOptions<Awaited<ReturnType<typeof getPaymentsUrl>>> = {}
) => {
  return useQuery({
    queryKey: getUsePaymentsUrlQueryKey(locationId),
    queryFn: async () => getPaymentsUrl(locationId),
    ...getInterScreenQueryOptions(),
    ...options,
    enabled: !!locationId && options.enabled !== false, // Only run the query if locationId is provided
  });
};
